import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Label,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Typography from "@mui/material/Typography";
import { Button, Card, CardContent, CircularProgress, Container, Divider } from "@mui/material";
import theme from "../styles/customTheme"
import { getURLBase } from "../utils/helperFns";
import { Box } from "@mui/system";

import axios from 'axios';
import { Link } from "react-router-dom";
import { GradientButton } from "../components/ui-components/GradientButton";

class MaxYouCanSave extends React.Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/maxyoucansave";
    this.state = {
      isReady: false,
    };
  }

  componentDidMount() {
    if (!this.state.isReady)
      axios.post(this.url, { gid: this.props.gid }).then(
        (response) => {
          this.processData(response.data.body)
        }
      )
  }

  buttonPositions = [];

  processData = (response) => {
    let textdata = response.text;
    let piedata = [];

    let c = new Map(Object.entries(response.credit));
    let d = new Map(Object.entries(response.debit));

    let total = 0;
    for (const [k, v] of d.entries()) {
      piedata.push({ name: k, value: v });
      total += v;
    }

    for (const [k, v] of c.entries()) {
      piedata.push({ name: k, value: v });
      total += v;
    }

    this.setState({
      piedata: piedata,
      textdata: textdata,
      total: total,
      isReady: true,
      shouldBlur: response.shouldBlur,
      tutorial_iframe: response.tutorial_iframe,
    });
  };

  render = () => {
    const CenterLabel = ({ viewBox, amount = 0 }) => {
      const { cx, cy } = viewBox;
      return (
        <React.Fragment>
          <text x={cx} y={cy - 7} textAnchor="middle" dominantBaseline="central" className="chart-label chart-label-small">
            <tspan

            >
              £{amount}
            </tspan>
            <br />
          </text>
          <text x={cx} y={cy + 8} textAnchor="middle" dominantBaseline="central">
            <tspan
              fill="grey"
            >
              or more
            </tspan>
          </text>
        </React.Fragment>
      );
    };

    const COLORS = [theme.palette.grey[300], theme.palette.success.main];
    const renderCustomizedLabel = ({
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      name,
      value,
    }) => {
      const RADIAN = Math.PI / 180;
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      const fx = x > cx ? x + 10 : x - 25;
      const fy = y > cy ? y + 20 : y - 20;
      return (
        <text
          x={fx}

          fill="black"
          className="recharts-text recharts-label chart-label chart-label-small"
          textAnchor={fx > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          <tspan className={`chart-label ${name === "saved" ? "chart-label-big" : "chart-label-small"}`}
            y={fy}
          >
            £{value}
          </tspan>

          <tspan
            x={fx}
            y={name === "saved" ? fy + 25 : fy + 15}
            fill="gray"
            className="chart-label chart-label-small"
          >
            {name}
          </tspan>
        </text>
      );
    };

    const WidgetData = () => (
      <Card className={"widgetCard cardShadow "} elevation={2} sx={{ width: "100%", position: "relative" }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }} align="center">
          Max You Can Save
        </Typography>
        <Typography
          variant="subtitle1"
          color="text.secondary"
          fontWeight="600"
          align="center"
          gutterBottom
        >
          this month
        </Typography>

        <Divider light />
        <CardContent textAlign="center" className={`${this.state.isReady ? (`${(this.state.total === null || this.state.shouldBlur
        /* TODO: SID: UNCOMMENT THIS CHECK  || this.state.total === 0 */) ? "blur" : ""}`) : ""}`}>
          {!this.state.isReady ?
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}>
              <CircularProgress color="success" />
            </Box>
            :
            <Box>
              <Container className="chartContainer" >
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={this.state.piedata}
                      label={renderCustomizedLabel}
                      labelLine={false}
                      outerRadius={100}
                      innerRadius={80}
                      fill="#8884d8"
                      paddingAngle={0}
                      dataKey="value"
                      verticalAlign="center"
                      startAngle={180}
                      endAngle={-180}
                    >
                      <Label
                        content={<CenterLabel amount={Math.round(this.state.total * 100) / 100} />}
                        position="center"
                      />
                      {this.state.piedata.map((entry, index) => (
                        <Cell fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>

                </ResponsiveContainer>



              </Container>
              <Box textAlign={"center"}>
                <GradientButton
                  sx={{ marginTop: 2 }}
                  component={Link}
                  to="/money/sweep"
                  variant="text"
                >
                  Save now
                </GradientButton>
              </Box>
              <Button sx={{
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "-0.9rem !important",
                marginTop: "0.2rem !important",
                // fontSize: "0.7rem",
                padding: "2px"
              }}
                onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
              >
                See how this works <img src="/tutorial-icon.png" style={{ width: "40px", padding: "5px" }} />
              </Button>
            </Box>


          }

        </CardContent>
      </Card>
    );
    return <WidgetData />;
  };
}

export default MaxYouCanSave;
